var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card',{attrs:{"title":"公司资料"}},[_c('section',[_c('qx-detail-box',{attrs:{"data":_vm.detailData.base}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }